<template>
  <div id="app">
    <router-view></router-view>
    <InventoryTicker />
    <CookieConsent />
  </div>
</template>

<script>
import CookieConsent from './components/CookieConsent.vue'
import InventoryTicker from './components/InventoryTicker.vue'

export default {
  name: 'App',
  components: {
    CookieConsent,
    InventoryTicker
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-base-content);
  margin: 0;
}
/* Feel free to adjust or add more styles */
</style>